import { render, staticRenderFns, recyclableRender, components } from "./myIntegral.vue?vue&type=template&id=1999c7e9&scoped=true&"
var renderjs
import script from "./myIntegral.vue?vue&type=script&lang=js&"
export * from "./myIntegral.vue?vue&type=script&lang=js&"
import style0 from "./myIntegral.vue?vue&type=style&index=0&id=1999c7e9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_@dcloudio_vue-cli-plugin-uni@2.0.0-28320200727001@@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1999c7e9",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/personalCenter/myIntegral.vue"
export default component.exports